export default "__VITE_ASSET__mj9doPOm__"